export const CheckSuccessIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 22C13.9174 22 16.7153 20.8411 18.7782 18.7782C20.8411 16.7153 22 13.9174 22 11C22 8.08262 20.8411 5.28473 18.7782 3.22183C16.7153 1.15893 13.9174 0 11 0C8.08262 0 5.28473 1.15893 3.22183 3.22183C1.15893 5.28473 0 8.08262 0 11C0 13.9174 1.15893 16.7153 3.22183 18.7782C5.28473 20.8411 8.08262 22 11 22ZM16.0971 9.22213C16.3476 8.9628 16.4862 8.61547 16.4831 8.25495C16.4799 7.89443 16.3353 7.54956 16.0804 7.29462C15.8254 7.03969 15.4806 6.89508 15.1201 6.89195C14.7595 6.88881 14.4122 7.02741 14.1529 7.27788L9.625 11.8058L7.84712 10.0279C7.5878 9.77741 7.24047 9.63882 6.87995 9.64195C6.51943 9.64508 6.17456 9.78969 5.91962 10.0446C5.66469 10.2996 5.52008 10.6444 5.51695 11.0049C5.51381 11.3655 5.65241 11.7128 5.90288 11.9721L8.65287 14.7221C8.91073 14.9799 9.2604 15.1247 9.625 15.1247C9.9896 15.1247 10.3393 14.9799 10.5971 14.7221L16.0971 9.22213Z"
      fill="#54A600"
    />
  </svg>
);

export const CheckFailureIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5 11C21.5 13.7848 20.3938 16.4555 18.4246 18.4246C16.4555 20.3938 13.7848 21.5 11 21.5C8.21523 21.5 5.54451 20.3938 3.57538 18.4246C1.60625 16.4555 0.5 13.7848 0.5 11C0.5 8.21523 1.60625 5.54451 3.57538 3.57538C5.54451 1.60625 8.21523 0.5 11 0.5C13.7848 0.5 16.4555 1.60625 18.4246 3.57538C20.3938 5.54451 21.5 8.21523 21.5 11ZM12.3258 17.8258C12.6775 17.4742 12.875 16.9973 12.875 16.5C12.875 16.0027 12.6775 15.5258 12.3258 15.1742C11.9742 14.8225 11.4973 14.625 11 14.625C10.5027 14.625 10.0258 14.8225 9.67418 15.1742C9.32255 15.5258 9.125 16.0027 9.125 16.5C9.125 16.9973 9.32255 17.4742 9.67417 17.8258C10.0258 18.1775 10.5027 18.375 11 18.375C11.4973 18.375 11.9742 18.1775 12.3258 17.8258ZM11 3.625C10.5027 3.625 10.0258 3.82254 9.67418 4.17417C9.32255 4.52581 9.125 5.00272 9.125 5.5V11C9.125 11.4973 9.32255 11.9742 9.67417 12.3258C10.0258 12.6775 10.5027 12.875 11 12.875C11.4973 12.875 11.9742 12.6775 12.3258 12.3258C12.6775 11.9742 12.875 11.4973 12.875 11V5.5C12.875 5.00272 12.6775 4.52581 12.3258 4.17418C11.9742 3.82254 11.4973 3.625 11 3.625Z"
      fill="#FF7164"
      stroke="#FF7164"
    />
  </svg>
);

export const ErrorIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4998 8.99688C15.4998 10.7208 14.815 12.3741 13.596 13.5931C12.377 14.8121 10.7237 15.4969 8.9998 15.4969C7.2759 15.4969 5.6226 14.8121 4.40361 13.5931C3.18462 12.3741 2.4998 10.7208 2.4998 8.99688C2.4998 7.27297 3.18462 5.61967 4.40361 4.40068C5.6226 3.18169 7.2759 2.49687 8.9998 2.49687C10.7237 2.49687 12.377 3.18169 13.596 4.40068C14.815 5.61967 15.4998 7.27297 15.4998 8.99688ZM10.1312 13.7282C10.4312 13.4282 10.5998 13.0212 10.5998 12.5969C10.5998 12.1725 10.4312 11.7656 10.1312 11.4655C9.83112 11.1654 9.42415 10.9969 8.9998 10.9969C8.57546 10.9969 8.16849 11.1654 7.86843 11.4655C7.56838 11.7656 7.39981 12.1725 7.39981 12.5969C7.39981 13.0212 7.56838 13.4282 7.86843 13.7282C8.16849 14.0283 8.57546 14.1969 8.9998 14.1969C9.42415 14.1969 9.83112 14.0283 10.1312 13.7282ZM8.9998 3.79688C8.57546 3.79688 8.16849 3.96545 7.86843 4.2655C7.56838 4.56556 7.39981 4.97253 7.39981 5.39688V8.99688C7.39981 9.42122 7.56838 9.82819 7.86843 10.1282C8.16849 10.4283 8.57546 10.5969 8.9998 10.5969C9.42415 10.5969 9.83112 10.4283 10.1312 10.1282C10.4312 9.82819 10.5998 9.42122 10.5998 8.99688V5.39688C10.5998 4.97253 10.4312 4.56556 10.1312 4.2655C9.83112 3.96545 9.42415 3.79688 8.9998 3.79688Z"
      fill="#FF7164"
      stroke="#FF7164"
      strokeWidth="1.4"
    />
  </svg>
);
